import { doc, getDoc } from 'firebase/firestore/lite'

const getDocRef = (id, collection) => doc(collection, id)

export default getDocRef
